import React, { useEffect, useState } from "react";
import { Box, Button, Dialog, Typography } from "@mui/material";
import InputWithLabel from "../../shared/components/InputWithLabel";
import CustomPrimaryButton from "../../shared/components/CustomPrimaryButton";
import Avatar from "../../shared/components/Avatar";
import * as api from "../../api";
import { fileToDataUrl } from "../../shared/utils/files";
import { connect } from "react-redux";
import { getActions } from "../../store/actions/authActions";

const PasswordDialog = ({ open, onClose }) => {
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [status, setStatus] = useState("");

  const handlePasswordUpdate = async () => {
    const response = await api.updatePassword({ currentPassword, newPassword, confirmPassword });
    setStatus(response.error ? response.exception?.response?.data : "Пароль обновлен");
    if (!response.error) {
      setCurrentPassword("");
      setNewPassword("");
      setConfirmPassword("");
    }
  };

  return (
    <Dialog open={open} onClose={onClose} PaperProps={{ sx:{ bgcolor:"#282a30", color:"#f2f3f5", borderRadius:"8px", width:"480px", p:"24px" } }}>
      <Typography sx={{ fontSize:"20px", fontWeight:800 }}>Обновите пароль</Typography>
      <InputWithLabel label="Текущий пароль" value={currentPassword} setValue={setCurrentPassword} type="password" placeholder="" />
      <InputWithLabel label="Новый пароль" value={newPassword} setValue={setNewPassword} type="password" placeholder="" />
      <InputWithLabel label="Подтверждение нового пароля" value={confirmPassword} setValue={setConfirmPassword} type="password" placeholder="" />
      {status && <Typography sx={{ color:"#b5bac1", mt:"12px", fontSize:"14px" }}>{status}</Typography>}
      <Box sx={{ display:"flex", gap:"12px", mt:"22px" }}>
        <CustomPrimaryButton label="Отмена" onClick={onClose} additionalStyles={{ background:"#4e5058" }} />
        <CustomPrimaryButton label="Готово" onClick={handlePasswordUpdate} disabled={!currentPassword || !newPassword || !confirmPassword} />
      </Box>
    </Dialog>
  );
};

const ProfileSettingsDialog = ({ open, onClose, userDetails, setUserDetails }) => {
  const [displayName, setDisplayName] = useState("");
  const [avatarUrl, setAvatarUrl] = useState("");
  const [status, setStatus] = useState("");
  const [isPasswordOpen, setIsPasswordOpen] = useState(false);

  useEffect(() => {
    if (open) {
      setDisplayName(userDetails?.displayName || userDetails?.username || "");
      setAvatarUrl(userDetails?.avatarUrl || "");
      setStatus("");
    }
  }, [open, userDetails]);

  const handleAvatarChange = async (event) => {
    const file = event.target.files?.[0];
    if (!file) {
      return;
    }
    setAvatarUrl(await fileToDataUrl(file));
  };

  const handleSaveProfile = async () => {
    const response = await api.updateProfile({ displayName, avatarUrl });
    if (response.error) {
      setStatus(response.exception?.response?.data || "Не удалось сохранить профиль");
      return;
    }
    const nextUser = { ...userDetails, ...response.data.userDetails };
    localStorage.setItem("user", JSON.stringify(nextUser));
    setUserDetails(nextUser);
    setStatus("Профиль сохранен");
  };

  return (
    <>
      <Dialog open={open} onClose={onClose} PaperProps={{ sx:{ bgcolor:"#282a30", color:"#f2f3f5", borderRadius:"8px", width:"480px", p:"24px" } }}>
        <Typography sx={{ fontSize:"20px", fontWeight:800 }}>Профиль</Typography>
        <Box sx={{ display:"flex", alignItems:"center", gap:"14px", mt:"18px" }}>
          <Avatar username={userDetails?.username} displayName={displayName} avatarUrl={avatarUrl} large />
          <Button component="label" sx={{ color:"#fff", bgcolor:"#3a3c43", textTransform:"none", "&:hover":{bgcolor:"#4e5058"} }}>
            Аватарка
            <input hidden type="file" accept="image/*" onChange={handleAvatarChange} />
          </Button>
        </Box>
        <InputWithLabel label="Отображаемое имя" value={displayName} setValue={setDisplayName} type="text" placeholder="" />
        {status && <Typography sx={{ color:"#b5bac1", mt:"12px", fontSize:"14px" }}>{status}</Typography>}
        <Box sx={{ display:"flex", gap:"12px", mt:"22px" }}>
          <CustomPrimaryButton label="Смена пароля" onClick={() => setIsPasswordOpen(true)} additionalStyles={{ background:"#4e5058" }} />
          <CustomPrimaryButton label="Сохранить" onClick={handleSaveProfile} disabled={displayName.trim().length < 2} />
        </Box>
      </Dialog>
      <PasswordDialog open={isPasswordOpen} onClose={() => setIsPasswordOpen(false)} />
    </>
  );
};

const mapStoreStateToProps = ({ auth }) => ({ userDetails: auth.userDetails });

export default connect(mapStoreStateToProps, getActions)(ProfileSettingsDialog);
